import axios from "axios";
import "./clientsPage.css";
import Clients from "../clients";
import { useEffect, useState } from "react";
import ClientsData from "../dataFiles/ClientsData";
const ClientsPage = () => {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);
   useEffect(()=>{if(ClientsData){setLoader(false)}},[])
  const getApi = () => {
    setLoader(true);
    const config = {
      url: "https://bestdealelectricalsbackend.onrender.com/bestdealelectricals/clients",
      method: "get",
      headers: {},
    };
    axios(config)
      .then((res) => {
        setLoader(false);
        setData(res.data.data);
      })
      .catch((err) => {
        console.log("err", err);
        setLoader(false);
      });
  };
  useEffect(() => {
    getApi();
  }, []);
  const [Hospitals, setHospitals] = useState([]);
  const [Jewellers, setJewellers] = useState([]);
  const [Banks, setBanks] = useState([]);
  const [Industries, setIndustries] = useState([]);
  const [CommercialRealEstate, setCommercialRealEstate] = useState([]);
  const [SchoolUniversities, setSchoolUniversities] = useState([]);
  const [Gym, setGym] = useState([]);

  
  useEffect(() => {
  setHospitals(data.filter((item) => item.category === "Hospitals"));
  setJewellers(data.filter((item) => item.category === "Jewellers"));
  setBanks(data.filter((item) => item.category === "Banks"));
  setIndustries(data.filter((item) => item.category === "Industries"));
  setCommercialRealEstate(
    data.filter((item) => item.category === "Commercial&RealEstate")
  );
  setSchoolUniversities(
    data.filter((item) => item.category === "School&Universities")
  );
  setGym(data.filter((item) => item.category === "Gym"));
}, [data]);


  return (
    <>
      <section className="py-5 client-page">
       <div className="position-relative heading-container mx-auto ">
            <h2 className="heading ">
              C<span className="heading-span ">LIENTS</span>{" "}
            </h2>
            <div className="line products-line"></div>
          </div>
        {loader ? (
          <>
            <div className="loader"></div>
          </>
        ) : (
          <>
           
              <div className="container">
         

     <div className="position-relative mt-5 client-heading">
        
           <h2 className="heading clients-category">
            I<span className="heading-span clients-category-span">NDUSTRIES</span>
          </h2>
          <div className="line"></div>
         </div>

               <div className="row">
                {Industries?.map((items) => {
                  return (
                   
                      <div className="col-sm-6 col-md-4 col-lg-3 gap-4 py-3 client-img-container" key={items._id}>
                        <div className="d-flex justify-content-center align-items-center  clients-container  p-4 ">
                          <img src={items.image} className="clients-image" />
                        </div>
                      </div>
                    
                  );
                })}
              </div>


                   <div className="position-relative mt-5 client-heading">
          <h2 className="heading clients-category">
            S<span className="heading-span clients-category-span">CHOOLS</span> / U<span className="heading-span clients-category-span">NIVERSITIES</span>
          </h2>
          <div className="line"></div>
         </div>
        

              <div className="row">
           
                {SchoolUniversities?.map((items) => {
                  return (
                   
                      <div className="col-sm-6 col-md-4 col-lg-3 gap-4 py-3" key={items._id}>
                        <div className="d-flex justify-content-center align-items-center  clients-container  p-4 ">
                          <img src={items.image} className="clients-image" />
                        </div>
                      </div>
                    
                  );
                })}
              </div>


 <div className="position-relative mt-5 client-heading">
          <h2 className="heading clients-category">
            C<span className="heading-span clients-category-span">OMMERCIAL</span> / R<span className="heading-span clients-category-span">EAL</span> E<span className="heading-span clients-category-span">STATE</span>
          </h2>
          <div className="line"></div>
         </div>
        

              <div className="row">
           
                {CommercialRealEstate?.map((items) => {
                  return (
                   
                      <div className="col-sm-6 col-md-4 col-lg-3 gap-4 py-3" key={items._id}>
                        <div className="d-flex justify-content-center align-items-center  clients-container  p-4 ">
                          <img src={items.image} className="clients-image" />
                        </div>
                      </div>
                    
                  );
                })}
              </div>


              
     <div className="position-relative mt-5 client-heading">
          <h2 className="heading clients-category">
            H<span className="heading-span clients-category-span">OSPITALS</span>
          </h2>
          <div className="line"></div>
         </div>
        

              <div className="row">
           
                {Hospitals?.map((items) => {
                  return (
                   
                      <div className="col-sm-6 col-md-4 col-lg-3 gap-4 py-3" key={items._id}>
                        <div className="d-flex justify-content-center align-items-center  clients-container  p-4 ">
                          <img src={items.image} className="clients-image" />
                        </div>
                      </div>
                    
                  );
                })}
              </div>

 <div className="position-relative mt-5 client-heading">
          <h2 className="heading clients-category">
            J<span className="heading-span clients-category-span">EWELLERS</span>
          </h2>
          <div className="line"></div>
         </div>
        

              <div className="row">
           
                {Jewellers?.map((items) => {
                  return (
                   
                      <div className="col-sm-6 col-md-4 col-lg-3 gap-4 py-3" key={items._id}>
                        <div className="d-flex justify-content-center align-items-center  clients-container  p-4 ">
                          <img src={items.image} className="clients-image" />
                        </div>
                      </div>
                    
                  );
                })}
              </div>





               <div className="position-relative mt-5 client-heading">
          <h2 className="heading clients-category">
            B<span className="heading-span clients-category-span">ANK</span>
          </h2>
          <div className="line"></div>
         </div>
        

              <div className="row">
           
                {Banks?.map((items) => {
                  return (
                   
                      <div className="col-sm-6 col-md-4 col-lg-3 gap-4 py-3" key={items._id}>
                        <div className="d-flex justify-content-center align-items-center  clients-container  p-4 ">
                          <img src={items.image} className="clients-image" />
                        </div>
                      </div>
                    
                  );
                })}
              </div>



               <div className="position-relative mt-5 client-heading">
          <h2 className="heading clients-category">
            G<span className="heading-span clients-category-span">YM</span>
          </h2>
          <div className="line"></div>
         </div>
        

              <div className="row">
           
                {Gym?.map((items) => {
                  return (
                   
                      <div className="col-sm-6 col-md-4 col-lg-3 gap-4 py-3" key={items._id}>
                        <div className="d-flex justify-content-center align-items-center  clients-container  p-4 ">
                          <img src={items.image} className="clients-image" />
                        </div>
                      </div>
                    
                  );
                })}
              </div>


         


            </div>
            {/* <div className="clientsPage-slider d-flex justify-content-center py-5 mt-5">
            <div className="col-11">
              <Clients />
            </div>
            </div> */}
          </>
        )}
      </section>
    </>
  );
};
export default ClientsPage;
